import React, { useEffect, useMemo } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import StudentRightsCheck from "./StudentRightsCheck";

import imgTimetable from "../../assets/images/icons/classes.svg";
import imgDiary from "../../assets/images/dashboard_icon/clipboard.svg";

const MODULE_MAP = {
  "class-timetable": {
    title: "Class Time Table",
    icon: imgTimetable,
    description:
      "This feature is coming soon. Your class timetable will be available here.",
  },
  "students-diary": {
    title: "Students Diary",
    icon: imgDiary,
    description:
      "This feature is coming soon. Diary notes and homework updates will appear here.",
  },
};

function StudentPanelModuleComingSoon() {
  const { moduleSlug } = useParams();

  const moduleConfig = useMemo(
    () => (moduleSlug ? MODULE_MAP[moduleSlug] : null),
    [moduleSlug]
  );

  useEffect(() => {
    document.title = moduleConfig
      ? `${moduleConfig.title} - Student Panel`
      : "Student Panel";
  }, [moduleConfig]);

  if (!moduleConfig) {
    return <Navigate to="/student-panel/dashboard" replace />;
  }

  return (
    <>
      <StudentRightsCheck />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/student-panel/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {moduleConfig.title}
                    </li>
                  </ol>
                </nav>
                <div className="page-title">{moduleConfig.title}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container body-content">
        <div className="card">
          <div className="card-body text-center py-5">
            <img
              src={moduleConfig.icon}
              alt=""
              className="mb-3"
              style={{ maxWidth: "80px", opacity: 0.85 }}
            />
            <h5 className="mb-2">{moduleConfig.title}</h5>
            <p className="text-muted mb-0">{moduleConfig.description}</p>
            <Link
              to="/student-panel/dashboard"
              className="btn btn-primary mt-3"
            >
              Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentPanelModuleComingSoon;
